module.exports = __webpack_public_path__ + "img/menu_tk.a64ee6ac.png";